import React from 'react'
import PropTypes from 'prop-types'
import yup from 'yup'
import Form from 'react-formal'
import EmailImage from '../../../img/icons/general-icons/email_icon.png'

var forgotSchema = yup.object({
  email: yup.string().email('Ingrese un email valido').required('Ingrese su email')
})

export default class ForgotForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({ model: {} })
  }

  sendEmail (e) {
    e.preventDefault()
    let email = this.state.model.email
    this.props.recovery(email)
  }

  render () {
    return (
      <Form id='forgotForm' className='form' schema={forgotSchema} value={this.state.model} onChange={model => this.setState({ model })}>
        <div className='form-field-container'>
          <img className='form-field-image' src={EmailImage} />
          <Form.Field name='email' id='email' ref='email' type='text' className='form-field-input' placeholder='Email' />
          <Form.Message className='message' for='email'/>
        </div>
        <div className='form-submit-btn-container'>
          <Form.Button id='forgotPassword' className='form-submit-button' type='submit' onClick={this.sendEmail.bind(this)}>Enviar</Form.Button>
        </div>
      </Form>
    )
  }
}

/* Validate props */
ForgotForm.propTypes = {
  recovery: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/Account/Forgot/ForgotForm.js